function assertNoDuplicateValues(arr) {
  const seen = new Set();
  for (const el of arr) {
    const v = el?.key; // adjust if your key differs
    if (seen.has(v)) {
      throw new Error(`Duplicate value found: ${String(v)}`);
    }
    seen.add(v);
  }
}

export { assertNoDuplicateValues };
